module.exports = __webpack_public_path__ + "img/icon_befund_u_co.12bc3153.svg";